'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _components = require('components');

var _footer = require('./footer.scss');

var _footer2 = _interopRequireDefault(_footer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(props, context) {
  var strings = props.strings;


  return _react2.default.createElement(
    'footer',
    { className: 'footer' },
    _react2.default.createElement(
      'p',
      null,
      strings.text
    )
  );
};

Footer.contextTypes = {
  baseUrl: _propTypes2.default.string.isRequired,
  project: _propTypes2.default.string.isRequired
};

exports.default = Footer;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Layout/Footer/Footer.jsx
// module id = 701
// module chunks = 0